import React from 'react';
import { useParams } from 'react-router-dom';

function CategoryPage() {
  const { slug } = useParams();
  return (
    <div data-testid="rwm-category-page">
      <h1 className="h5">Category: {slug}</h1>
      <p className="text-muted">Job listings for this category will appear here.</p>
    </div>
  );
}

export default CategoryPage;